import {apiPost, API_URL} from '../api'

export const editAdvertisement = async data => {
    return await apiPost(API_URL, 'admin/ad_edit', data)
}
